import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

import Breadcrumb from "../../../../components/Common/Breadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";
import showNotification from "../../../../helpers/show_notification";
import {
  ExportAvailableInCSVForReports,
  formatUnitsForReport,
} from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";

const SupplierReturnReport = (props) => {
  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }
  const { SearchBar } = Search;
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  const [isLoadingOrders, setIsLoadingOrders] = useState(false);
  const [pageSize, setPageSize] = useState(50);
  const ordersRequestId = useRef(0);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  useEffect(() => {
    if (dateFrom > dateTo) {
      setFilteredOrders([]);
      setAllOrders([]);
    }
  }, [dateFrom, dateTo]);

  const [allOrders, setAllOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);

  const loadOrders = async () => {
    const requestId = ++ordersRequestId.current;
    try {
      const daysDiff = moment(dateTo).diff(dateFrom, "days");
      if (daysDiff > 31) {
        setFilteredOrders([]);
        showNotification(
          "Total number of days cannot be more than 31.",
          "Error",
        );
        return false;
      } else if (daysDiff < 0) {
        setFilteredOrders([]);
        showNotification("Invalid date range.", "Error");
        return false;
      }

      setIsLoadingOrders(true);
      setFilteredOrders([]);
      const url = process.env.REACT_APP_BASEURL + "itemreturns/report";
      const response = await postSubmitForm(url, {
        date_from: dateFrom ? dateFrom : moment().format("YYYY-MM-DD"),
        date_to: dateTo ? dateTo : moment().format("YYYY-MM-DD"),
        store_id: "All",
      });
      if (requestId !== ordersRequestId.current) return false;
      if (response && response.status === 1) {
        const allData = (response.data || []).map((row, index) => ({
          ...row,
          row_key:
            row.id ||
            `${row._id}_${row.item_id || index}_${row.batch || index}`,
          branch_name:
            row.branch_details && row.branch_details.name
              ? row.branch_details.name
              : "",
          supplier_name:
            row.supplier_details && row.supplier_details.name
              ? row.supplier_details.name
              : "",
        }));
        if (allData.length <= 0) {
          showNotification("No Orders data found", "error");
        }
        setAllOrders(allData);
        setFilteredOrders(allData);
      } else {
        showNotification((response && response.message) || "Error", "Error");
      }
    } catch (error) {
      if (requestId !== ordersRequestId.current) return false;
      console.log(error);
    } finally {
      if (requestId === ordersRequestId.current) {
        setIsLoadingOrders(false);
      }
    }
  };

  const [detailsModal, setDetailsModal] = useState();
  const [selectedTransfer_Items, setSelectedTransfer_Items] = useState([]);

  const columns = [
    {
      dataField: "row_key",
      hidden: true,
    },
    {
      dataField: "serial",
      isDummyField: true,
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "branch_name",
      text: props.t("Return From"),
      sort: true,
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.branch_name)
                .map((row) => [
                  row.branch_name,
                  { value: row.branch_name, label: row.branch_name },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
      headerStyle: () => ({ width: "15%" }),
    },
    {
      dataField: "return_id",
      text: props.t("Return/PO Details"),
      formatter: (cell, row) => (
        <div>
          <div className="d-flex align-items-center justify-content-between mb-2">
            <span className="">Return ID</span>
            <a
              href={"/return_order?return_id=" + row._id}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "underline",
                color: "blue",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  color: "blue",
                }}
              >
                {" "}
                {row.return_id}{" "}
              </span>
            </a>
          </div>
          {row.po_id && (
            <div className="d-flex align-items-center justify-content-between">
              <span className="">PO ID</span>
              <a
                href={"/purchase_order?po_id=" + row.po_id}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    marginLeft: "8px",
                    color: "blue",
                  }}
                >
                  {" "}
                  {row.po_id}{" "}
                </span>
              </a>
            </div>
          )}
        </div>
      ),
      headerStyle: () => ({ width: "15%" }),
    },
    {
      dataField: "name",
      text: props.t("Item Details"),
      sort: true,
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.name)
                .map((row) => [row.name, { value: row.name, label: row.name }]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
      formatter: (cell, row) => (
        <div>
          <div>{row.name}</div>
          <small className="text-muted">
            {row.category} / {row.sub_category}
          </small>
          {row.batch && (
            <div className="text-muted small">Batch: {row.batch}</div>
          )}
        </div>
      ),
      headerStyle: () => ({ width: "18%" }),
    },
    {
      dataField: "supplier_name",
      text: props.t("Supplier Info"),
      formatter: (cell, row) => (
        <div>
          <div>{row.supplier_name}</div>
          {row.supplier_details?.mobile && (
            <small className="text-muted">
              <i className="mdi mdi-phone me-1"></i>{" "}
              {row.supplier_details?.mobile}
            </small>
          )}
        </div>
      ),
      sort: true,
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.supplier_name)
                .map((row) => [
                  row.supplier_name,
                  { value: row.supplier_name, label: row.supplier_name },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
      headerStyle: () => ({ width: "15%" }),
    },
    {
      dataField: "quantity",
      text: props.t("Quantity & Price"),
      formatter: (cell, row) => (
        <div>
          <div>{formatUnitsForReport(row.quantity)}</div>
          <small className="text-muted">
            Cost: {row.cost_price}/{row.unit_for_po}
          </small>
        </div>
      ),
      headerStyle: () => ({ width: "15%" }),
    },
    {
      dataField: "return_details",
      isDummyField: true,
      text: props.t("Return Details"),
      formatter: (cell, row) => (
        <div>
          <div
            className={`badge badge-${
              row.return_to_supplier ? "warning" : "info"
            }`}
          >
            {row.return_to_supplier ? "To Supplier" : "To Central Store"}
          </div>
          <div className="small mt-1">
            <i className="mdi mdi-calendar me-1"></i>{" "}
            {moment(row.created_at).format("DD/MM/YYYY")}
          </div>
          {row.remarks && (
            <div className="small">
              <i className="mdi mdi-comment-text-outline me-1"></i>{" "}
              {row.remarks}
            </div>
          )}
        </div>
      ),
      headerStyle: () => ({ width: "18%" }),
    },
    {
      dataField: "status",
      text: props.t("Status"),
      formatter: (cell, row) => (
        <div
          className={`badge badge-${
            row.status === "Closed"
              ? "success"
              : row.status === "Pending"
                ? "warning"
                : "info"
          }`}
        >
          {row.status}
        </div>
      ),
      sort: true,
      filter: selectFilter({
        options: () => {
          const unique = [
            ...new Map(
              allOrders
                .filter((row) => row && row.status)
                .map((row) => [
                  row.status,
                  { value: row.status, label: row.status },
                ]),
            ).values(),
          ];
          return unique.sort(dynamicSort("label"));
        },
      }),
      headerStyle: () => ({ width: "10%" }),
    },
    {
      dataField: "total_price",
      text: props.t("Total"),
      formatter: (cell, row) => {
        return row.total_price ? row.total_price.toFixed(2) : " ";
      },
      headerStyle: () => ({ width: "10%" }),
    },
  ];

  const columns_items = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: props.t("Name"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Category"),
      dataField: "category",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Batch"),
      dataField: "batch",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Ret. Supp. ?"),
      dataField: "return_to_supplier",
      formatter: (cell, row, rowIndex) => {
        return row.return_to_supplier ? "Yes" : "No";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      text: props.t("Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return row.quantity?.length > 0
          ? formatUnitsForReport(row.quantity)
          : null;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },
    {
      text: props.t("Expiry Date"),
      dataField: "expiry_date",
      sort: false,
      formatter: (cell, row) => {
        return row.expiry_date
          ? moment(row.expiry_date).format("DD/MM/YYYY HH:mm")
          : "";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "11%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Cost Price"),
      formatter: (cell, row) => {
        return row.cost_price + "/" + row.unit_for_po;
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "total_price",
      text: props.t("Total"),
      formatter: (cell, row) => {
        return row?.total_price?.toFixed(2) || 0;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Closed") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "d" || row.status === "Dispatched") {
      style.backgroundColor = "#fffd9e";
    } else if (row.status === "Placed") {
      style.backgroundColor = "#ff9e9e";
    }

    return style;
  };

  function afterFilter(newResult, newFilters) {
    setFilteredOrders((prevOrders) => {
      const next = newResult || [];
      if (
        prevOrders.length === next.length &&
        prevOrders.every((row, index) => row === next[index])
      ) {
        return prevOrders;
      }
      return next;
    });
  }

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} - {to} of {size} records.
    </span>
  );

  const pagination_options = {
    sizePerPage: pageSize,
    onSizePerPageChange: (sizePerPage) => {
      setPageSize(sizePerPage);
    },
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Prev",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "200", value: 200 },
    ],
    hideSizePerPage: false,
    ignoreSinglePage: true,
  };

  const handleDownload = async () => {
    const fileName = "supplier_return_report";
    const exportType = "xls";

    let data_to_export =
      filteredOrders && filteredOrders.length ? filteredOrders : allOrders;
    if (data_to_export) {
      var data = [];
      data_to_export.forEach(function (v) {
        data.push({
          "Return ID": v.return_id,
          "PO ID": v.po_id,
          "Item Name": v.name,
          Category: v.category,
          "Sub Category": v.sub_category,
          Batch: v.batch,
          "Return From": v.branch_name,
          "Return To":
            v.return_to?.supplier == null
              ? v.return_to?.central_store?.name
              : v.return_to?.supplier?.name,
          "Return Type": v.return_to_supplier ? "To Supplier" : "To Store",
          Quantity: ExportAvailableInCSVForReports(v.quantity),
          "Cost Price": `${v.cost_price}/${v.unit_for_po}`,
          "Total Price": v.total_price?.toFixed(2) || 0,
          "Return Date": v.created_at
            ? moment(v.created_at).format("DD/MM/YYYY")
            : "",
          "Expiry Date": v.expiry_date
            ? moment(v.expiry_date).format("DD/MM/YYYY")
            : "",
          Remarks: v.remarks || "",
          Status: v.status,
        });
      });

      exportFromJSON({
        data,
        fileName,
        exportType,
      });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Supplier Return Report")}
            title={props.t("Reports")}
            breadcrumbItem={props.t("Supplier Return Report")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={3}>
                        <AvField
                          name="dateFrom"
                          label={props.t("From Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateFrom}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateFrom(formatDate(selectedDate));

                            const maxDate = moment(selectedDate)
                              .add(30, "days")
                              .format("YYYY-MM-DD");
                            const currentDate = moment().format("YYYY-MM-DD");

                            if (
                              moment(dateTo).isAfter(maxDate) ||
                              moment(dateTo).isAfter(currentDate)
                            ) {
                              setDateTo(
                                maxDate > currentDate ? currentDate : maxDate,
                              );
                            }
                          }}
                          max={moment().format("YYYY-MM-DD")}
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="dateTo"
                          label={props.t("To Date")}
                          placeholder={props.t("Select")}
                          type="date"
                          value={dateTo}
                          onChange={(e) => {
                            const selectedDate = e.target.value;
                            setDateTo(formatDate(selectedDate));
                          }}
                          min={dateFrom}
                          max={
                            moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD") >
                            moment().format("YYYY-MM-DD")
                              ? moment().format("YYYY-MM-DD")
                              : moment(dateFrom)
                                  .add(30, "days")
                                  .format("YYYY-MM-DD")
                          }
                          errorMessage={props.t("Date cannot be empty.")}
                          validate={{ required: { value: true } }}
                        />
                      </Col>
                      <Col lg={3}>
                        <Button
                          type="button"
                          className="btn btn-md btn-success mt-4"
                          disabled={isLoadingOrders}
                          onClick={() => {
                            if (dateFrom && dateTo) {
                              loadOrders();
                            }
                          }}
                        >
                          <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                          {props.t("Check")}
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="button"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"   "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("Supplier Return Report");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="Supplier Return Report">
                    <CardTitle className="text-center">
                      {props.t("Supplier Return Report")}
                    </CardTitle>
                    <ToolkitProvider
                      keyField="row_key"
                      data={allOrders && allOrders}
                      columns={columns}
                      bootstrap4
                      search
                    >
                      {(toolkitProps) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...toolkitProps.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}></Col>
                            <Col lg={4}></Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            filter={filterFactory({ afterFilter })}
                            condensed
                            pagination={paginationFactory(pagination_options)}
                            rowStyle={rowStyle}
                            noDataIndication={
                              isLoadingOrders ? (
                                <Spinner size="md" />
                              ) : (
                                props.t("No data to display.")
                              )
                            }
                            {...toolkitProps.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="lg"
            style={{
              width: "980px",
              maxWidth: "990px",
            }}
            isOpen={detailsModal}
            toggle={() => setDetailsModal(!detailsModal)}
          >
            <ModalHeader toggle={() => setDetailsModal(!detailsModal)}>
              Return Item Details
            </ModalHeader>
            <ModalBody>
              {selectedTransfer_Items && (
                <>
                  <Row>
                    <Col lg={12}>
                      <Card>
                        <CardBody>
                          <Row>
                            <Col lg={12}>
                              <ToolkitProvider
                                keyField="_id"
                                data={
                                  selectedTransfer_Items &&
                                  selectedTransfer_Items
                                }
                                columns={columns_items}
                              >
                                {(toolkitProps) => (
                                  <div>
                                    <BootstrapTable
                                      {...toolkitProps.baseProps}
                                      noDataIndication="No data to display."
                                      striped
                                      hover
                                      condensed
                                    />
                                  </div>
                                )}
                              </ToolkitProvider>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(SupplierReturnReport)),
);
